export default __webpack_public_path__ + "static/media/ethereum Logo.56be968d.svg";